import React, {useState} from 'react';
import { connect } from 'react-redux';
import { Link, Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import Page from '../../pages/page/page';
import SearchPage from '../../pages/search/SearchPage';
import NotFound from '../../pages/NotFound';
import { Component as NavigationMenu } from '../../components/cms/SiteNavigation';
import { history } from '../../../config/redux.store';
import { Layout, Input } from 'antd';
import { fetchSinglePage, clearSinglePage } from '../../../actions/singlePage.actions';
import { fetchSingleTemplate, clearSingleTemplate } from '../../../actions/templates.actions';
import queryString from 'query-string';
import Mark from "mark.js/src/lib/mark";

const { Header, Sider, Content, Footer } = Layout;
const { Search } = Input;

const Publish = props => {

    const [collapsedSider, setCollapsedSider] = useState(false);

    const handleCollapseNavMenuClicked = collapsed => {
        setCollapsedSider(collapsed);
    };

    const createHighlightBlock = e => {
        let instance = new Mark(document.querySelector(".pageContent"));
        instance.unmark();

        if (e.target.value !== '') {
            instance.mark(e.target.value);
        }
    };

    const handleHighlight = e => {
        createHighlightBlock(e);
    };

    const handleSearch = value => {
        if (value !== '') {
            const encodedStr = queryString.stringify({ query: value });
            history.push({
                pathname: '/search',
                search: '?' + encodedStr
            });
        }
    };

    return (
        <Layout className="layout">
            <Header theme="dark" className="header">
                <ConnectedRouter history={history}>
                    <div className="logo">
                        <Link to="/" className="logo__link">
                            <img src="https://upload.wikimedia.org/wikipedia/fr/7/74/Logo_Barry_Callebaut.svg" width="200" alt="Barry callebaut logo" />
                        </Link>
                    </div>
                    <Search placeholder="Search" className="unifiedSearchField" onChange={handleHighlight} onSearch={handleSearch} style={{ width: 400, float: 'right', paddingTop: 16, paddingBottom: 16 }} enterButton />
                </ConnectedRouter>
            </Header>
            <Layout style={{ marginTop: '64px', overflow:'hidden'}}>
                <Sider collapsed={collapsedSider} width={350} className="publishedPageNav">
                    <ConnectedRouter history={history}>
                        <NavigationMenu onCollapsePressed={handleCollapseNavMenuClicked} history={props.history} />
                    </ConnectedRouter>
                </Sider>
                <Layout className="layout publishedPageContent">
                    <ConnectedRouter history={history}>
                        <Content className="content">
                            <Switch>
                                <Route path="/search" component={SearchPage} />
                                <Route path="/" component={Page} />
                                <Route component={NotFound} />
                            </Switch>
                        </Content>
                        <Footer className="footer">&copy; Barry Callebaut</Footer>
                    </ConnectedRouter>
                </Layout>
            </Layout>
        </Layout>
    );
};

const mapStateToProps = state => ({
    page: state.page.page,
    index: state.pages.index,
    template: state.templates.template
});
const mapDispatchToProps = {
    fetchSinglePage,
    fetchSingleTemplate,
    clearSinglePage,
    clearSingleTemplate
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Publish);
